import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { createPageUrl } from '@/lib/utils';
import { Medal } from 'lucide-react';

export default function AthleteCard({ athlete, index }) {
  const totalMedals = (athlete.medals?.gold || 0) + (athlete.medals?.silver || 0) + (athlete.medals?.bronze || 0);

  return (
    <motion.div
      initial={{ opacity: 0, scale: 0.8 }}
      animate={{ opacity: 1, scale: 1 }}
      transition={{ 
        duration: 0.5, 
        delay: index * 0.1,
        ease: 'easeOut'
      }}
      whileHover={{ scale: 1.05 }}
      className="flex flex-col items-center"
    >
      <Link 
        to={createPageUrl('AthleteDetail') + `?id=${athlete.id}`}
        className="group relative"
      >
        {/* Photo/Initial container */}
        <div className="relative w-32 h-32 md:w-36 md:h-36 rounded-full overflow-hidden athlete-circle transition-all duration-300 group-hover:scale-105">
          {athlete.photo_url ? (
            <img
              src={athlete.photo_url}
              alt={athlete.name}
              className="w-full h-full object-cover opacity-80 group-hover:opacity-100 transition-opacity duration-300"
            />
          ) : (
            <div className="w-full h-full flex items-center justify-center">
              <span className="text-4xl md:text-5xl font-thin text-white/90">
                {athlete.name?.charAt(0)}
              </span>
            </div>
          )}

          {/* Overlay on hover */}
          <motion.div
            className="absolute inset-0 bg-blue-900/20 opacity-0 group-hover:opacity-100 transition-opacity duration-300"
          />
        </div>

        {/* Medal indicator - simplified */}
        {totalMedals > 0 && (
          <motion.div
            className={`absolute -top-1 -right-1 w-6 h-6 rounded-full flex items-center justify-center shadow-lg border border-white/10 ${
              athlete.medals?.gold > 0 ? 'bg-[#d4af37]' :
              athlete.medals?.silver > 0 ? 'bg-[#C0C0C0]' :
              'bg-[#CD7F32]'
            }`}
            initial={{ scale: 0 }}
            animate={{ scale: 1 }}
            transition={{ delay: index * 0.1 + 0.3 }}
          >
            <Medal className="w-3 h-3 text-white" />
          </motion.div>
        )}
      </Link>

      {/* Name */}
      <motion.div
        className="mt-6 text-center"
        initial={{ opacity: 0, y: 10 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: index * 0.1 + 0.2 }}
      >
        <h3 className="text-white font-normal text-sm md:text-base tracking-wide mb-1">
          {athlete.name}
        </h3>
        <p className="text-blue-400/70 text-[10px] md:text-xs tracking-widest uppercase font-light">
          {athlete.sport}
        </p>
      </motion.div>
    </motion.div>
  );
}